<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useReviewReportStore } from '@/store';

const { exitedStudents } = storeToRefs(useReviewReportStore());

const hasTotals = computed(() => Object.keys(exitedStudents.value.data).length);

const totals = computed(() => {
  return exitedStudents.value.data.map((item) => {
    return {
      total: new Intl.NumberFormat().format(item.total),
      reason: item.archived_reason.reason,
    };
  });
});
</script>

<template>
  <div class="p-3 surface-100 border-round-xl">
    <div class="flex align-items-center>">
      <h3 class="flex-1 text-base text-color-secondary mb-2">Exited Students</h3>
      <Icon
        v-tooltip.left="'Total Students that have been archived within the system.'"
        name="info"
        class="text-gray-400 text-base cursor-pointer"
      />
    </div>
    <div v-if="hasTotals" class="flex gap-2">
      <div v-for="(item, key) in totals" :key="key" class="p-2 border-round bg-white">
        <div class="text-color-gray text-sm" v-text="item.reason" />
        <Skeleton v-if="exitedStudents.loading" height="1rem" class="mt-1" />
        <div v-else class="text-color-gray text-lg font-bold" v-text="item.total" />
      </div>
    </div>
    <p v-else class="py-8 text-center text-color-secondary">
      <span v-if="exitedStudents.loading">Searching for Exited Students</span>
      <span v-else>No data for Exited Students</span>
    </p>
  </div>
</template>
